// frontend-react/src/pages/ResetPassword.js

import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { resetPassword } from '../api/api';
import './LoginPage.css'; // Χρησιμοποιούμε τα ίδια styles

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const token = searchParams.get('token');

    useEffect(() => {
        if (!token) {
            setError('Invalid or missing password reset token.');
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password.length < 8) {
            setError('Password must be at least 8 characters long.');
            return;
        }
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
        if (!token) {
            setError('Cannot reset password without a valid token.');
            return;
        }

        setLoading(true);
        setError('');
        setMessage('');

        try {
            const response = await resetPassword(token, password);
            setMessage(response.data.message + ' Redirecting to login...');
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            setError(err.response?.data?.detail || 'An error occurred. The token might be expired or invalid.');
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
         return (
            <div className="login-page">
                <div className="login-container">
                    <h1>ALGOSTOCK CAPITAL</h1>
                    <h2>Invalid Link</h2>
                    <p className="error-message">The password reset link is invalid or missing.</p>
                     <div className="auth-link" style={{ marginTop: '2rem' }}>
                        <Link to="/forgot-password">Request a new link</Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-page">
             <div className="login-container">
                <h1>ALGOSTOCK CAPITAL</h1>
                <h2>Set New Password</h2>
                <form onSubmit={handleSubmit} className="login-form">
                    <input
                        type="password"
                        placeholder="New Password (min 8 chars)"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Confirm New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    <button type="submit" disabled={loading || message}>
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </button>
                </form>
                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
            </div>
        </div>
    );
};

export default ResetPassword;